!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.remixPlugin = t() : e.remixPlugin = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 10);
  }([function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.extendsProfile = function e(t) {
      for (var n = [], o = 1; o < arguments.length; o++) {
        n[o - 1] = arguments[o];
      }

      var i = {};
      return n.length > 1 ? i = n.reduce(function (t, n) {
        return e(t, n);
      }, {}) : 1 === n.length && (i = n[0]), r({}, i, t, {
        methods: n.reduce(function (e, t) {
          return e.concat(t.methods || []);
        }, []).concat(t.methods || []),
        events: n.reduce(function (e, t) {
          return e.concat(t.events || []);
        }, []).concat(t.events || []),
        notifications: r({}, n.reduce(function (e, t) {
          return r({}, e, t.notifications || {});
        }, {}), t.notifications || {})
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(2),
        s = n(0);
    t.baseProfile = {
      name: "base",
      events: ["statusChanged"],
      methods: ["getStatus"],
      notifications: {
        theme: ["themeChanged"]
      }
    };

    var a = function () {
      function e(e) {
        this.requestQueue = [], this.name = e.name, this.events = new i.EventEmitter(), this.profile = s.extendsProfile(e, t.baseProfile);
      }

      return e.prototype.setStatus = function (e) {
        this.status = e, this.events.emit("statusChanged", e);
      }, e.prototype.getStatus = function () {
        return this.status;
      }, e.prototype.api = function () {
        var e = this;
        return {
          events: this.events,
          name: this.profile.name,
          profile: this.profile,
          render: this.render ? function () {
            return e.render();
          } : void 0,
          activate: this.activate ? function () {
            return e.activate();
          } : void 0,
          deactivate: this.deactivate ? function () {
            return e.deactivate();
          } : void 0,
          addRequest: function addRequest(t, n, i) {
            return new Promise(function (s, a) {
              e.profile.methods && e.profile.methods.includes(n) || a(new Error("Method " + n + " is not exposed by " + e.profile.name)), n in e || a(new Error("Method " + n + " is not implemented by " + e.profile.name)), e.requestQueue.push(function () {
                return r(e, void 0, void 0, function () {
                  var e, r;
                  return o(this, function (o) {
                    switch (o.label) {
                      case 0:
                        this.currentRequest = t, o.label = 1;

                      case 1:
                        return o.trys.push([1, 3,, 4]), [4, this[n].apply(this, i)];

                      case 2:
                        return e = o.sent(), s(e), [3, 4];

                      case 3:
                        return r = o.sent(), a(r), [3, 4];

                      case 4:
                        return delete this.currentRequest, this.requestQueue.shift(), 0 !== this.requestQueue.length && this.requestQueue[0](), [2];
                    }
                  });
                });
              }), 1 === e.requestQueue.length && e.requestQueue[0]();
            });
          }
        };
      }, e;
    }();

    t.BaseApi = a;
  }, function (e, t, n) {
    "use strict";

    var r,
        o = "object" == typeof Reflect ? Reflect : null,
        i = o && "function" == typeof o.apply ? o.apply : function (e, t, n) {
      return Function.prototype.apply.call(e, t, n);
    };
    r = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : function (e) {
      return Object.getOwnPropertyNames(e);
    };

    var s = Number.isNaN || function (e) {
      return e != e;
    };

    function a() {
      a.init.call(this);
    }

    e.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
    var u = 10;

    function c(e) {
      return void 0 === e._maxListeners ? a.defaultMaxListeners : e._maxListeners;
    }

    function f(e, t, n, r) {
      var o, i, s, a;
      if ("function" != typeof n) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
      if (void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), i = e._events), s = i[t]), void 0 === s) s = i[t] = n, ++e._eventsCount;else if ("function" == typeof s ? s = i[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), (o = c(e)) > 0 && s.length > o && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = s.length, a = u, console && console.warn && console.warn(a);
      }
      return e;
    }

    function l(e, t, n) {
      var r = {
        fired: !1,
        wrapFn: void 0,
        target: e,
        type: t,
        listener: n
      },
          o = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e.push(arguments[t]);
        }

        this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, i(this.listener, this.target, e));
      }.bind(r);

      return o.listener = n, r.wrapFn = o, o;
    }

    function p(e, t, n) {
      var r = e._events;
      if (void 0 === r) return [];
      var o = r[t];
      return void 0 === o ? [] : "function" == typeof o ? n ? [o.listener || o] : [o] : n ? function (e) {
        for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
          t[n] = e[n].listener || e[n];
        }

        return t;
      }(o) : d(o, o.length);
    }

    function h(e) {
      var t = this._events;

      if (void 0 !== t) {
        var n = t[e];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length;
      }

      return 0;
    }

    function d(e, t) {
      for (var n = new Array(t), r = 0; r < t; ++r) {
        n[r] = e[r];
      }

      return n;
    }

    Object.defineProperty(a, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(e) {
        if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        u = e;
      }
    }), a.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, a.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
      return this._maxListeners = e, this;
    }, a.prototype.getMaxListeners = function () {
      return c(this);
    }, a.prototype.emit = function (e) {
      for (var t = [], n = 1; n < arguments.length; n++) {
        t.push(arguments[n]);
      }

      var r = "error" === e,
          o = this._events;
      if (void 0 !== o) r = r && void 0 === o.error;else if (!r) return !1;

      if (r) {
        var s;
        if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
        throw a.context = s, a;
      }

      var u = o[e];
      if (void 0 === u) return !1;
      if ("function" == typeof u) i(u, this, t);else {
        var c = u.length,
            f = d(u, c);

        for (n = 0; n < c; ++n) {
          i(f[n], this, t);
        }
      }
      return !0;
    }, a.prototype.addListener = function (e, t) {
      return f(this, e, t, !1);
    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (e, t) {
      return f(this, e, t, !0);
    }, a.prototype.once = function (e, t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
      return this.on(e, l(this, e, t)), this;
    }, a.prototype.prependOnceListener = function (e, t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
      return this.prependListener(e, l(this, e, t)), this;
    }, a.prototype.removeListener = function (e, t) {
      var n, r, o, i, s;
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
      if (void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[e])) return this;
      if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
        for (o = -1, i = n.length - 1; i >= 0; i--) {
          if (n[i] === t || n[i].listener === t) {
            s = n[i].listener, o = i;
            break;
          }
        }

        if (o < 0) return this;
        0 === o ? n.shift() : function (e, t) {
          for (; t + 1 < e.length; t++) {
            e[t] = e[t + 1];
          }

          e.pop();
        }(n, o), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t);
      }
      return this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (e) {
      var t, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;

      if (0 === arguments.length) {
        var o,
            i = Object.keys(n);

        for (r = 0; r < i.length; ++r) {
          "removeListener" !== (o = i[r]) && this.removeAllListeners(o);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) {
        this.removeListener(e, t[r]);
      }
      return this;
    }, a.prototype.listeners = function (e) {
      return p(this, e, !0);
    }, a.prototype.rawListeners = function (e) {
      return p(this, e, !1);
    }, a.listenerCount = function (e, t) {
      return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
    }, a.prototype.listenerCount = h, a.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : [];
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(12));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(13));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(14));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(15));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }(n(16));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(2);

    function o(e) {
      var t = e ? "Make sure the port of the IDE is " + e.port : "If you are using a local IDE, make sure to add devMode in client options";
      throw new Error("Not connected to the IDE. " + t);
    }

    function i(e, t, n) {
      return "[" + e + "] " + t + "-" + n;
    }

    function s(e, t) {
      return "[" + e + "] " + t;
    }

    t.defaultOptions = {
      customTheme: !1,
      customApi: []
    }, t.handleConnectionError = o, t.callEvent = i, t.listenEvent = s;

    var a = function () {
      function e(e) {
        var t = this;
        void 0 === e && (e = {}), this.loaded = !1, this.id = 0, this.events = new r.EventEmitter(), e.devMode && (this.devMode = e.devMode), this.events.once("loaded", function () {
          t.loaded = !0, t.loadedCB && t.loadedCB();
        });
      }

      return e.prototype.onload = function (e) {
        var t = this;
        return new Promise(function (n, r) {
          var o = function o() {
            n(), e && e();
          };

          t.loaded ? o() : t.loadedCB = o;
        });
      }, e.prototype.call = function (e, t) {
        for (var n = this, r = [], s = 2; s < arguments.length; s++) {
          r[s - 2] = arguments[s];
        }

        return this.loaded || o(this.devMode), this.id++, new Promise(function (o, s) {
          var a = i(e, t, n.id);
          n.events.once(a, function (e, t) {
            var n = Array.isArray(e) ? e : [e];
            t ? s(new Error("Error from IDE : " + t)) : o.apply(void 0, n);
          }), n.events.emit("send", {
            action: "request",
            name: e,
            key: t,
            payload: r,
            id: n.id
          });
        });
      }, e.prototype.on = function (e, t, n) {
        var r = s(e, t);
        this.events.on(r, n);
      }, e.prototype.emit = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        this.loaded || o(this.devMode), this.events.emit("send", {
          action: "notification",
          key: e,
          payload: t
        });
      }, e;
    }();

    t.PluginClient = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    function s(e, t) {
      if ("string" != typeof t.name) throw new Error("Profile should have a name");
      var n = (t.methods || []).reduce(function (n, o) {
        var i;
        return r({}, n, ((i = {})[o] = e.call.bind(e, t.name, o), i));
      }, {});
      return r({
        on: function on(n, r) {
          e.on.call(e, t.name, n, r);
        }
      }, n);
    }

    function a(e, t) {
      e.setAttribute("href", t.url), document.documentElement.style.setProperty("--theme", t.quality);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createApi = s, t.getApiMap = function (e, t) {
      return t.reduce(function (t, n) {
        var o;
        if (!n.name) throw new Error("A profile need a name to be used as API");
        return r({}, t, ((o = {})[n.name] = s(e, n), o));
      }, {});
    }, t.listenOnThemeChanged = function (e, t) {
      var n = this;

      if (!t || !t.customTheme) {
        var r = document.createElement("link");
        return r.setAttribute("rel", "stylesheet"), document.head.appendChild(r), e.on("theme", "themeChanged", function (e) {
          a(r, e);
        }), e.onload(function () {
          return o(n, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, e.call("theme", "currentTheme")];

                case 1:
                  return t = n.sent(), a(r, t), [2];
              }
            });
          });
        }), r;
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(11)), r(n(18)), r(n(19)), r(n(8)), r(n(20)), r(n(9));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r(n(0)), r(n(1)), r(n(3)), r(n(4)), r(n(5)), r(n(6)), r(n(7)), r(n(17));
  }, function (e, t, n) {
    "use strict";

    var _r,
        o = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        s = n(0);
    t.compilerProfile = {
      name: "compiler",
      kind: "compiler",
      events: ["compilationFinished"],
      methods: ["getCompilationResult", "compile"]
    };

    var a = function (e) {
      function n(n) {
        var r = s.extendsProfile(n, t.compilerProfile);
        return e.call(this, r) || this;
      }

      return o(n, e), n;
    }(i.BaseApi);

    t.CompilerApi = a;
  }, function (e, t, n) {
    "use strict";

    var _r2,
        o = this && this.__extends || (_r2 = function r(e, t) {
      return (_r2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        s = n(0);
    t.editorProfile = {
      name: "editor",
      kind: "editor",
      methods: ["highlight", "discardHighlight"]
    };

    var a = function (e) {
      function n(n) {
        var r = s.extendsProfile(n, t.editorProfile);
        return e.call(this, r) || this;
      }

      return o(n, e), n;
    }(i.BaseApi);

    t.EditorApi = a;
  }, function (e, t, n) {
    "use strict";

    var _r3,
        o = this && this.__extends || (_r3 = function r(e, t) {
      return (_r3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        s = n(0);
    t.networkProfile = {
      name: "network",
      kind: "network",
      events: ["providerChanged"],
      methods: ["getNetworkProvider", "getEndpoint", "detectNetwork", "addNetwork", "removeNetwork"]
    };

    var a = function (e) {
      function n(n) {
        var r = s.extendsProfile(n, t.networkProfile);
        return e.call(this, r) || this;
      }

      return o(n, e), n;
    }(i.BaseApi);

    t.NetworkApi = a;
  }, function (e, t, n) {
    "use strict";

    var _r4,
        o = this && this.__extends || (_r4 = function r(e, t) {
      return (_r4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        s = n(0);
    t.udappProfile = {
      name: "udapp",
      kind: "udapp",
      events: ["newTransaction"],
      methods: ["sendTransaction", "getAccounts", "createVMAccount"]
    };

    var a = function (e) {
      function n(n) {
        var r = s.extendsProfile(n, t.udappProfile);
        return e.call(this, r) || this;
      }

      return o(n, e), n;
    }(i.BaseApi);

    t.UdappApi = a;
  }, function (e, t, n) {
    "use strict";

    var _r5,
        o = this && this.__extends || (_r5 = function r(e, t) {
      return (_r5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(1),
        s = n(0);
    t.fileSystemProfile = {
      name: "fs",
      kind: "fs",
      events: ["currentFileChanged"],
      methods: ["getFolder", "getCurrentFile", "getFile", "setFile", "switchFile"]
    };

    var a = function (e) {
      function n(n) {
        var r = s.extendsProfile(n, t.fileSystemProfile);
        return e.call(this, r) || this;
      }

      return o(n, e), n;
    }(i.BaseApi);

    t.FileSystemApi = a;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(0),
        s = n(7),
        a = n(4),
        u = n(6),
        c = n(5),
        f = r({}, o.compilerProfile, {
      name: "solidity"
    }),
        l = r({}, s.fileSystemProfile, {
      name: "fileManager"
    });
    t.remixApi = [i.extendsProfile(f, o.compilerProfile), i.extendsProfile(l, s.fileSystemProfile), a.editorProfile, u.udappProfile, c.networkProfile];
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(2),
        s = function () {
      function e() {
        this.eventmanager = {}, this.calls = {}, this.name = "appManager", this.events = new i.EventEmitter();
      }

      return e.prototype.isPlugin = function (e) {
        return e.profile.url;
      }, e.prototype.init = function (e) {
        var t = this;
        e.forEach(function (e) {
          e.profile.required = !0, t.registerOne(e), t.activateOne(e.profile.name);
        });
      }, e.prototype.registerMany = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.registerOne(e);
        });
      }, e.prototype.registerOne = function (e) {
        !e.profile.location && this.defaultLocation && (e.profile.location = this.defaultLocation), this.addEntity(e), this.events.emit("register", e.profile.name);
      }, e.prototype.activateMany = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.activateOne(e);
        });
      }, e.prototype.activateOne = function (e) {
        var t = this.getEntity(e);
        this.activateCallAndEvent(t), this.isPlugin(t) && this.activateRequestAndNotification(t), !this.isPlugin(t) && t.activate && t.activate(), this.setActive(e, !0), this.events.emit("activate", t);
      }, e.prototype.activateCallAndEvent = function (e) {
        var t = this;
        (e.profile.events || []).forEach(function (n) {
          if (e.events) {
            e.events.on(n, function () {
              for (var r = [], o = 0; o < arguments.length; o++) {
                r[o] = arguments[o];
              }

              return t.broadcast(e.name, n, r);
            });
          }
        });
        var n = e.profile.methods || [];
        this.calls[e.name] = {}, n.forEach(function (n) {
          t.calls[e.name][n] = function (t) {
            for (var r = [], o = 1; o < arguments.length; o++) {
              r[o - 1] = arguments[o];
            }

            return e.addRequest(t, n, r);
          };
        });
      }, e.prototype.activateRequestAndNotification = function (e) {
        var t = this;

        e.request = function (n) {
          var i = n.name,
              s = n.key,
              a = n.payload;
          return r(t, void 0, void 0, function () {
            var t, n, r;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return o.trys.push([0, 3,, 4]), (n = this.getEntity(i)).profile.permission ? [4, this.permissionHandler.askPermission(e.profile, n.profile)] : [3, 2];

                case 1:
                  o.sent(), o.label = 2;

                case 2:
                  return Array.isArray(a) || (a = [a]), r = {
                    from: e.name
                  }, [2, (t = this.calls[i])[s].apply(t, [r].concat(a))];

                case 3:
                  throw o.sent();

                case 4:
                  return [2];
              }
            });
          });
        };

        var n = e.profile.notifications || {},
            i = function i(r) {
          var o = e.profile.name;
          s.eventmanager[o] || (s.eventmanager[o] = {}), s.eventmanager[o][r] || (s.eventmanager[o][r] = {}), (n[r] || []).forEach(function (n) {
            t.eventmanager[o][r][n] = e.notifs[r][n];
          });
        },
            s = this;

        for (var a in n) {
          i(a);
        }
      }, e.prototype.deactivateMany = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.deactivateOne(e);
        });
      }, e.prototype.deactivateOne = function (e) {
        var t = this.getEntity(e);
        this.deactivateProfile(e), t.deactivate && t.deactivate(), this.setActive(e, !1), this.events.emit("deactivate", t.profile);
      }, e.prototype.deactivateProfile = function (e) {
        delete this.calls[e];
      }, e.prototype.broadcast = function (e, t, n) {
        for (var r in this.eventmanager) {
          if (this.eventmanager[r][e]) {
            var o = this.eventmanager[r][e];
            o[t] && o[t](n);
          }
        }
      }, e;
    }();

    t.AppManagerApi = s;
  }, function (e, t, n) {
    "use strict";

    var _r6,
        o = this && this.__extends || (_r6 = function r(e, t) {
      return (_r6 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        s = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        a = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        n.listener = ["message", function (e) {
          return n.getMessage(e);
        }, !1], n.id = 0, n.iframe = document.createElement("iframe"), n.pendingRequest = {}, n.requestQueue = [], n.notifs = {}, n.name = n.profile.name;

        var r = n.profile.notifications || {},
            o = function o(e) {
          i.notifs[e] = {}, (r[e] || []).forEach(function (t) {
            n.notifs[e][t] = function (r) {
              n.postMessage({
                action: "notification",
                name: e,
                key: t,
                payload: r
              });
            };
          });
        },
            i = this;

        for (var s in r) {
          o(s);
        }

        return n;
      }

      return o(t, e), t.prototype.getMessage = function (e) {
        return s(this, void 0, void 0, function () {
          var t, n, r, o, s, u, c, f;
          return a(this, function (a) {
            switch (a.label) {
              case 0:
                if (e.origin !== this.origin) return [2];

                switch (n = e.data, n.action) {
                  case "notification":
                    return [3, 1];

                  case "request":
                    return [3, 2];

                  case "response":
                    return [3, 7];
                }

                return [3, 8];

              case 1:
                return n.payload ? ((t = this.events).emit.apply(t, [n.key].concat(n.payload)), [3, 9]) : [3, 9];

              case 2:
                r = "response", a.label = 3;

              case 3:
                return a.trys.push([3, 5,, 6]), [4, this.request(n)];

              case 4:
                return f = a.sent(), s = void 0, this.postMessage(i({}, n, {
                  action: r,
                  payload: f,
                  error: s
                })), [3, 6];

              case 5:
                return o = a.sent(), f = void 0, s = o.message, this.postMessage(i({}, n, {
                  action: r,
                  payload: f,
                  error: s
                })), [3, 6];

              case 6:
                return [3, 9];

              case 7:
                return u = n.name, c = n.id, f = n.payload, this.pendingRequest[u][c](f), delete this.pendingRequest[u][c], [3, 9];

              case 8:
                throw new Error("Message should be a notification, request or response");

              case 9:
                return [2];
            }
          });
        });
      }, t.prototype.postMessage = function (e) {
        if (!this.source) throw new Error("No window attached to Iframe yet");
        this.source.postMessage(e, this.origin);
      }, t.prototype.addRequest = function (e, t, n) {
        var r = this;
        return new Promise(function (o, i) {
          r.profile.methods && r.profile.methods.includes(t) || i(new Error("Method " + t + " is not exposed by " + r.profile.name)), r.requestQueue.push(function () {
            return s(r, void 0, void 0, function () {
              var r = this;
              return a(this, function (i) {
                return this.id++, this.postMessage({
                  action: "request",
                  name: this.name,
                  key: t,
                  id: this.id,
                  payload: n,
                  requestInfo: e
                }), this.pendingRequest[this.name][this.id] = function (e) {
                  o(e), r.requestQueue.shift(), 0 !== r.requestQueue.length && r.requestQueue[0]();
                }, [2];
              });
            });
          }), 1 === r.requestQueue.length && r.requestQueue[0]();
        });
      }, t.prototype.render = function () {
        var e = this;
        if (this.iframe.contentWindow) throw new Error(this.name + " plugin is already rendered");
        return this.iframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms"), this.iframe.setAttribute("seamless", "true"), this.iframe.src = this.profile.url, this.iframe.onload = function () {
          if (!e.iframe.contentWindow) throw new Error(e.name + " plugin is cannot find url " + e.profile.url);
          window.addEventListener.apply(window, e.listener), e.origin = new URL(e.iframe.src).origin, e.source = e.iframe.contentWindow, e.postMessage({
            action: "request",
            name: e.name,
            key: "handshake"
          });
        }, this.iframe;
      }, t.prototype.deactivate = function () {
        this.iframe.remove(), window.removeEventListener.apply(window, this.listener);
      }, t;
    }(n(1).BaseApi);

    t.Plugin = u;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        o = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            u(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, a);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        i = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(8),
        a = n(9);

    function u(e, t) {
      var n = t ? ["http://127.0.0.1:" + t.port, "http://localhost:" + t.port, "https://127.0.0.1:" + t.port, "https://localhost:" + t.port] : [];
      return ["http://remix-alpha.ethereum.org", "http://remix.ethereum.org", "https://remix-alpha.ethereum.org", "https://remix.ethereum.org"].concat(n).includes(e);
    }

    function c(e) {
      var t = !1;
      window.addEventListener("message", function (n) {
        return o(this, void 0, void 0, function () {
          var r, o, a, c, f, l, p, h, d, v, y, m, w;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                if (!n.source) throw new Error("No source");
                if (o = e.devMode, !u(n.origin, o)) return [2];
                if (!n.data) throw new Error("No data");
                a = n.data, c = a.action, f = a.key, l = a.name, p = a.payload, h = a.id, d = a.requestInfo, v = a.error, i.label = 1;

              case 1:
                if (i.trys.push([1, 7,, 8]), "request" === c && "handshake" === f) return t = !0, e.events.on("send", function (e) {
                  n.source.postMessage(e, n.origin);
                }), e.events.emit("loaded"), [2];
                if (!t) throw new Error("Handshake before communicating");

                switch (c) {
                  case "notification":
                    return [3, 2];

                  case "response":
                    return [3, 3];

                  case "request":
                    return [3, 4];
                }

                return [3, 6];

              case 2:
                return (r = e.events).emit.apply(r, [s.listenEvent(l, f)].concat(p)), [3, 6];

              case 3:
                return e.events.emit(s.callEvent(l, f, h), p, v), [3, 6];

              case 4:
                if (!e[f]) throw new Error("Method " + f + " doesn't exist on plugin " + l);
                return e.currentRequest = d, [4, e[f].apply(e, p)];

              case 5:
                return y = i.sent(), w = {
                  action: "response",
                  name: l,
                  key: f,
                  id: h,
                  payload: y
                }, n.source.postMessage(w, n.origin), [3, 6];

              case 6:
                return [3, 8];

              case 7:
                return m = i.sent(), w = {
                  action: c,
                  name: l,
                  key: f,
                  id: h,
                  error: m.message
                }, n.source.postMessage(w, n.origin), [3, 8];

              case 8:
                return [2];
            }
          });
        });
      }, !1);
    }

    t.checkOrigin = u, t.connectIframe = c, t.createIframeClient = function (e) {
      void 0 === e && (e = {});
      var t = r({}, s.defaultOptions, e),
          n = new s.PluginClient(t),
          o = a.getApiMap(n, t.customApi);
      return Object.keys(o).forEach(function (e) {
        return n[e] = o[e];
      }), c(n), a.listenOnThemeChanged(n, t), n;
    };
  }]);
});